import { COMPOSE_ONLY_CONTENT_END, COMPOSE_ONLY_CONTENT_START } from './pluginConstants';

const contentToRemove = new RegExp(
    `<!--${COMPOSE_ONLY_CONTENT_START}-->.*?<!--${COMPOSE_ONLY_CONTENT_END}-->`,
    'gim'
);

export default function removeComposeOnlyContent(html: string): string {
    if (html) {
        return html.replace(contentToRemove, '');
    } else {
        return html;
    }
}
